/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandActivationCreative } from './BrandActivationCreative';
import {
    BrandActivationCreativeFromJSON,
    BrandActivationCreativeFromJSONTyped,
    BrandActivationCreativeToJSON,
    BrandActivationCreativeToJSONTyped,
} from './BrandActivationCreative';
import type { RewardAutoSettingsMap } from './RewardAutoSettingsMap';
import {
    RewardAutoSettingsMapFromJSON,
    RewardAutoSettingsMapFromJSONTyped,
    RewardAutoSettingsMapToJSON,
    RewardAutoSettingsMapToJSONTyped,
} from './RewardAutoSettingsMap';
import type { ActivationPlayableAdConfig } from './ActivationPlayableAdConfig';
import {
    ActivationPlayableAdConfigFromJSON,
    ActivationPlayableAdConfigFromJSONTyped,
    ActivationPlayableAdConfigToJSON,
    ActivationPlayableAdConfigToJSONTyped,
} from './ActivationPlayableAdConfig';
import type { SnapshotObjective } from './SnapshotObjective';
import {
    SnapshotObjectiveFromJSON,
    SnapshotObjectiveFromJSONTyped,
    SnapshotObjectiveToJSON,
    SnapshotObjectiveToJSONTyped,
} from './SnapshotObjective';
import type { ActivityProgression } from './ActivityProgression';
import {
    ActivityProgressionFromJSON,
    ActivityProgressionFromJSONTyped,
    ActivityProgressionToJSON,
    ActivityProgressionToJSONTyped,
} from './ActivityProgression';
import type { PlayableMissionAvailability } from './PlayableMissionAvailability';
import {
    PlayableMissionAvailabilityFromJSON,
    PlayableMissionAvailabilityFromJSONTyped,
    PlayableMissionAvailabilityToJSON,
    PlayableMissionAvailabilityToJSONTyped,
} from './PlayableMissionAvailability';

/**
 * 
 * @export
 * @interface PlayableMissionResponse
 */
export interface PlayableMissionResponse {
    /**
     * 
     * @type {string}
     * @memberof PlayableMissionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlayableMissionResponse
     */
    name: string;
    /**
     * 
     * @type {BrandActivationCreative}
     * @memberof PlayableMissionResponse
     */
    creative?: BrandActivationCreative;
    /**
     * 
     * @type {Array<SnapshotObjective>}
     * @memberof PlayableMissionResponse
     */
    objectives: Array<SnapshotObjective>;
    /**
     * 
     * @type {number}
     * @memberof PlayableMissionResponse
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof PlayableMissionResponse
     */
    endAt?: number;
    /**
     * 
     * @type {ActivationPlayableAdConfig}
     * @memberof PlayableMissionResponse
     */
    playableAdConfig?: ActivationPlayableAdConfig;
    /**
     * 
     * @type {Array<string>}
     * @memberof PlayableMissionResponse
     */
    bonusRewardConfigIds?: Array<string>;
    /**
     * 
     * @type {RewardAutoSettingsMap}
     * @memberof PlayableMissionResponse
     */
    rewardAutoSettings?: RewardAutoSettingsMap;
    /**
     * Asset ID for the game icon (resolved from the first objective's gameId)
     * @type {string}
     * @memberof PlayableMissionResponse
     */
    gameIconAssetId?: string;
    /**
     * 
     * @type {ActivityProgression}
     * @memberof PlayableMissionResponse
     */
    progression?: ActivityProgression;
    /**
     * 
     * @type {PlayableMissionAvailability}
     * @memberof PlayableMissionResponse
     */
    availability?: PlayableMissionAvailability;
}

/**
 * Check if a given object implements the PlayableMissionResponse interface.
 */
export function instanceOfPlayableMissionResponse(value: object): value is PlayableMissionResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('objectives' in value) || value['objectives'] === undefined) return false;
    return true;
}

export function PlayableMissionResponseFromJSON(json: any): PlayableMissionResponse {
    return PlayableMissionResponseFromJSONTyped(json, false);
}

export function PlayableMissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayableMissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'creative': json['creative'] == null ? undefined : BrandActivationCreativeFromJSON(json['creative']),
        'objectives': ((json['objectives'] as Array<any>).map(SnapshotObjectiveFromJSON)),
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'playableAdConfig': json['playableAdConfig'] == null ? undefined : ActivationPlayableAdConfigFromJSON(json['playableAdConfig']),
        'bonusRewardConfigIds': json['bonusRewardConfigIds'] == null ? undefined : json['bonusRewardConfigIds'],
        'rewardAutoSettings': json['rewardAutoSettings'] == null ? undefined : RewardAutoSettingsMapFromJSON(json['rewardAutoSettings']),
        'gameIconAssetId': json['gameIconAssetId'] == null ? undefined : json['gameIconAssetId'],
        'progression': json['progression'] == null ? undefined : ActivityProgressionFromJSON(json['progression']),
        'availability': json['availability'] == null ? undefined : PlayableMissionAvailabilityFromJSON(json['availability']),
    };
}

export function PlayableMissionResponseToJSON(json: any): PlayableMissionResponse {
    return PlayableMissionResponseToJSONTyped(json, false);
}

export function PlayableMissionResponseToJSONTyped(value?: PlayableMissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'creative': BrandActivationCreativeToJSON(value['creative']),
        'objectives': ((value['objectives'] as Array<any>).map(SnapshotObjectiveToJSON)),
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'playableAdConfig': ActivationPlayableAdConfigToJSON(value['playableAdConfig']),
        'bonusRewardConfigIds': value['bonusRewardConfigIds'],
        'rewardAutoSettings': RewardAutoSettingsMapToJSON(value['rewardAutoSettings']),
        'gameIconAssetId': value['gameIconAssetId'],
        'progression': ActivityProgressionToJSON(value['progression']),
        'availability': PlayableMissionAvailabilityToJSON(value['availability']),
    };
}

